module.exports = __webpack_public_path__ + "static/media/car.523d41fa.svg";